import { useRoutes } from 'react-router-dom'
// import { URL_TYPE, ERROR_BLOCK_TYPE } from 'src/utils/constants.js'
import { Home } from "pages/home/Home";
import { Service } from "pages/service/Service";
import { Mine } from "pages/mine/Mine";
import { Declaration } from "pages/service/form/Declaration";
import { EmployReg } from "pages/service/form/EmployReg";
import { UnitRegister } from "pages/service/form/UnitRegister";
import { ApplyCertificate } from "pages/service/form/ApplyCertificate";
import { Recruit } from "pages/service/form/Recruit";
import { SeekJob } from "pages/service/form/SeekJob";
import { Shop } from "pages/home/shop/Shop";
import { MarketInquiry } from "pages/home/marketInquiry";
import { Login } from "pages/home/login/Login";
import { LoginEnter } from "pages/home/login";
import { SelectList } from '../service/selectList';
import { RecordsQuery } from '../service/selectList/RecordsQuery';
import { ProgressCheck } from '../service/selectList/ProgressCheck';
import { Contribution } from '../service/form/Contribution';
import { EmpQuery } from '../service/form/EmpQuery';
import { WorkService } from 'pages/home/workService';
import { CheckLogin } from 'pages/mine/checkLogin';
import { AffirmEmployDev } from 'pages/service/form/AffirmEmployDev'
import { SubsidyDev } from 'pages/service/form/SubsidyDev'
import { ConditionCheck } from 'pages/service/ConditionCheck';
import { Recommend } from "pages/recommend/";
import { formName } from 'utils/constant';

const { AFFIRMEMPLOY, SUBSIDY } = formName

const routeConfig = [
  /* 首页 */
  { path: '/', element: <Home />, exact: true },
  { path: '/home', element: <Home />, exact: true },
  /**推荐*/
  {
    path: '/recommend',
    element: <Recommend />,
    exact: true
  },
  /**条件检验页面 */
  {
    path: '/conditionCheck',
    element: <ConditionCheck />,
    exact: true
  },

  /* 服务 */
  { path: '/service', element: <Service />, exact: true },
  /* 我的 */
  { path: '/mine', element: <Mine />, exact: true },
  /* 商城 */
  { path: '/shop', element: <Shop />, exact: true },
  /* 登录 */
  { path: '/loginEnter', element: <LoginEnter />, exact: true },
  { path: '/login', element: <Login />, exact: true },
  /* 失业登记 */
  { path: '/declaration', exact: true, element: <Declaration />, meta: { requiresAuth: true } },
  /* 就业登记 */
  { path: '/employs', exact: true, element: <EmployReg />, meta: { requiresAuth: true } },
  /* 就业创业电子证申领 */
  { path: '/apply', exact: true, element: <ApplyCertificate />, meta: { requiresAuth: true } },
  /* 我要招人 */
  { path: '/recruit', exact: true, element: <Recruit />, meta: { requiresAuth: true } },
  /* 用人单位备案 */
  { path: '/unitRegister', exact: true, element: <UnitRegister />, meta: { requiresAuth: true } },
  /* 就业困难人员认定：点击后的进入选择列表页 */
  { path: '/newAffirmEmploy', exact: true, element: <SelectList title={AFFIRMEMPLOY} />, meta: { requiresAuth: true } },

  /** 进入 就业困难人员认定 */
  {
    path: '/affirmEmploy', exact: true,
    element: <AffirmEmployDev />,
    meta: { requiresAuth: true }
  },
  /** 进入社会保险补贴 */
  {
    path: '/subsidy', exact: true,
    element: <SubsidyDev />,
    meta: { requiresAuth: true }
  },
  /* 我要就业 */
  { path: '/seekJob', exact: true, element: <SeekJob />, meta: { requiresAuth: true } },
  /* 社会保险补贴 ：点击后的进入选择列表页*/
  { path: '/newSubsidy', exact: true, element: <SelectList title={SUBSIDY} />, meta: { requiresAuth: true } },
  /**零工市场查询 */
  { path: '/marketInquiry', exact: true, element: <MarketInquiry />, meta: { requiresAuth: true } },
  /** 历史记录查询 */
  { path: '/recordsQuery', exact: true, element: <RecordsQuery />, meta: { requiresAuth: true } },
  /** 申请进度查询 */
  { path: '/progressCheck', exact: true, element: <ProgressCheck />, meta: { requiresAuth: true } },
  /**社保缴费情况 */
  { path: '/contribution', exact: true, element: <Contribution />, meta: { requiresAuth: true } },
  /**办事服务 */
  { path: '/workService', element: <WorkService />, exact: true },
  /**就失业登记记录查询 */
  { path: '/empQuery', element: <EmpQuery />, exact: true, meta: { requiresAuth: true } },
  /**中转路由，处理用户信息登录状态等 */
  { path: '/checkLogin', element: <CheckLogin />, exact: true },

  /* 404 */
  // { path: '*', element: <Home />, exact: true },
]

/** 路由配置*/
export const BaseRouter = () => {
  return useRoutes(routeConfig)
}

export { routeConfig }